export default () => process.env.REACT_APP_ENV === 'production';
